import React from 'react';
import useAccounts from 'context/useAccounts';

import MarketingBanner from 'components/marketingBanner/MarketingBanner';
import OverlaySpinner from 'components/spinner/OverlaySpinner';
import Statement from 'components/statements/Statements';

const StatementsPage = () => {
    const { hasAmountsPastDue, isFetchingAccounts } = useAccounts();
    return (
        <div className="home-page grey-banner">
            {isFetchingAccounts ? (
                <OverlaySpinner />
            ) : (
                <React.Fragment>
                    <Statement />
                    {!hasAmountsPastDue && <MarketingBanner />}
                </React.Fragment>
            )}
        </div>
    );
};

export default StatementsPage;
